'use strict';

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var OneLinkUrlGenerator = /*#__PURE__*/function () {
  // TODO -  add params documentation
  // oneLinkURL - your own basic OneLink URL
  // ...
  function OneLinkUrlGenerator() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      oneLinkURL = _ref.oneLinkURL,
      _ref$pidKeysList = _ref.pidKeysList,
      pidKeysList = _ref$pidKeysList === void 0 ? [] : _ref$pidKeysList,
      _ref$pidStaticValue = _ref.pidStaticValue,
      pidStaticValue = _ref$pidStaticValue === void 0 ? null : _ref$pidStaticValue,
      _ref$campaignKeysList = _ref.campaignKeysList,
      campaignKeysList = _ref$campaignKeysList === void 0 ? [] : _ref$campaignKeysList,
      _ref$campaignStaticVa = _ref.campaignStaticValue,
      campaignStaticValue = _ref$campaignStaticVa === void 0 ? null : _ref$campaignStaticVa,
      _ref$pidOverrideList = _ref.pidOverrideList,
      pidOverrideList = _ref$pidOverrideList === void 0 ? [] : _ref$pidOverrideList,
      _ref$gclIdParam = _ref.gclIdParam,
      gclIdParam = _ref$gclIdParam === void 0 ? 'af_sub5' : _ref$gclIdParam;
    _classCallCheck(this, OneLinkUrlGenerator);
    console.debug("Constructing OneLink URL generator");
    if (oneLinkURL === undefined || typeof oneLinkURL !== "string" || oneLinkURL === "") {
      console.error("OneLinkUrlGenerator: oneLinkURL arg invalid");
      return null;
    }
    this.oneLinkURL = oneLinkURL;
    this.pidOverrideList = pidOverrideList, this.gclIdParam = gclIdParam, this.pidKeysList = pidKeysList, this.pidStaticValue = pidStaticValue, this.campaignKeysList = campaignKeysList, this.campaignStaticValue = campaignStaticValue,
    // OneLink parameters
    this.campaign = getCampaignValue(this.campaignKeysList, this.campaignStaticValue);
    this.mediaSource = getMediaSourceValue(this.pidKeysList, this.pidStaticValue, this.pidOverrideList);

    // af_js_web=true will be added to every URL that was generated through this script
    this.afParams = {
      af_js_web: "true"
    };
  }
  return _createClass(OneLinkUrlGenerator, [{
    key: "generateUrl",
    value: function generateUrl() {
      if (this.mediaSource == null) {
        console.debug("No valid pid value was found. URL will no be changed");
        return null;
      }

      // User was redirected using af_r parameter on an AppsFlyer attribution link
      if (getParameterFromURL('af_redirect')) {
        console.debug("This user comes from AppsFlyer by redirection and is ready to be attributed. \nKeep direct app store links.");
        return null; // in this case, the original store links in the install buttons stay the same
      }
      if (isFacebook()) {
        console.debug("This user comes from a paid Facebook ad - don't do anything. \nKeep direct app store links.");
        // the caller should make sure a return value of null will leave the original link
        return null;
      }

      // Google Ads
      var pidValue = this.mediaSource;
      var gclIdValue = getParameterFromURL('gclid');
      if (gclIdValue) {
        this.afParams[this.gclIdParam] = gclIdValue;
        console.debug("This user comes from Google AdWords");
        var kwValue = getParameterFromURL('keyword');
        if (!!kwValue) {
          this.afParams['af_keywords'] = kwValue;
          console.debug("There is a keyword associated with the ad");
        }
        // Other SRNs, custom networks and organic installs
      } else {
        console.debug("This user comes from SRN or custom network ");
      }
      var finalURL = this.oneLinkURL + '?pid=' + pidValue + '&c=' + this.campaign + stringifyAfParameters(this.afParams);
      console.debug("Generated OneLink URL ".concat(finalURL));
      return finalURL;
    }

    // Setters for AF params
  }, {
    key: "setDeepLinkValue",
    value: function setDeepLinkValue(deepLinkValueParam) {
      var deepLinkValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'deep_link_value', deepLinkValueParam, deepLinkValue);
    }
  }, {
    key: "setChannel",
    value: function setChannel(channelParam) {
      var channelValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_channel', channelParam, channelValue);
    }
  }, {
    key: "setAdset",
    value: function setAdset(adsetParam) {
      var adsetValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_adset', adsetParam, adsetValue);
    }
  }, {
    key: "setAd",
    value: function setAd(adParam) {
      var adValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_ad', adParam, adValue);
    }
  }, {
    key: "setAfSub1",
    value: function setAfSub1(afSub1Param) {
      var afSub1Value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_sub1', afSub1Param, afSub1Value);
    }
  }, {
    key: "setAfSub2",
    value: function setAfSub2(afSub2Param) {
      var afSub2Value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'this.afParams, af_sub2', afSub2Param, afSub2Value);
    }
  }, {
    key: "setAfSub3",
    value: function setAfSub3(afSub3Param) {
      var afSub3Value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_sub3', afSub3Param, afSub3Value);
    }
  }, {
    key: "setAfSub4",
    value: function setAfSub4(afSub4Param) {
      var afSub4Value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_sub4', afSub4Param, afSub4Value);
    }
  }, {
    key: "setAfSub5",
    value: function setAfSub5(afSub5Param) {
      var afSub5Value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      setGenericParameter(this.afParams, 'af_sub5', afSub5Param, afSub5Value);
    }
  }, {
    key: "setCustomParameter",
    value: function setCustomParameter(searchKey, customKey) {
      var customValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      setGenericParameter(this.afParams, customKey, searchKey, customValue);
    }
  }]);
}(); // Statis state-less functions
// Note - when device ID sharing becomes optional stop calling this method (or always return false)
function isFacebook() {
  if (document.referrer && document.referrer != "") {
    return document.referrer.toLowerCase().includes('facebook');
  } else {
    return false;
  }
}
function getParameterFromURL(name) {
  var url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function getMediaSourceValue(pidKeysList, pidStaticValue, pidOverrideList) {
  var pidValue = null;
  var _iterator = _createForOfIteratorHelper(pidKeysList),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var pidKey = _step.value;
      if (pidKey != null && getParameterFromURL(pidKey)) {
        pidValue = getParameterFromURL(pidKey);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (pidValue != null) {
    if (pidOverrideList.hasOwnProperty(pidValue)) pidValue = pidOverrideList[pidValue];
  } else {
    pidValue = pidStaticValue;
  }
  return pidValue;
}
function getCampaignValue(campaignKeysList, campaignStaticValue) {
  var _iterator2 = _createForOfIteratorHelper(campaignKeysList),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var campaignKey = _step2.value;
      if (getParameterFromURL(campaignKey)) {
        return getParameterFromURL(campaignKey);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (campaignStaticValue != null) {
    return campaignStaticValue;
  }
  if (!!document.getElementsByTagName('title')[0]) {
    return document.getElementsByTagName('title')[0].innerText;
  }
  return 'unknown';
}

// Create a string of param and value from
function stringifyAfParameters(afParams) {
  var finalStr = "";
  for (var _i = 0, _Object$keys = Object.keys(afParams); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    console.debug(key + "->" + afParams[key]);
    if (afParams[key] != null) {
      finalStr += "&".concat(key, "=").concat(afParams[key]);
    }
  }
  return finalStr;
}
function setGenericParameter(afParams, oneLinkParam, searchKey) {
  var newParamValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var searchKeyResult = getParameterFromURL(searchKey);
  if (searchKeyResult) {
    afParams[oneLinkParam] = searchKeyResult;
    console.debug("".concat(searchKey, " found. ").concat(oneLinkParam, " = ").concat(searchKeyResult));
  } else {
    if (newParamValue != null) {
      afParams[oneLinkParam] = newParamValue;
      console.debug("".concat(searchKey, " not found. ").concat(oneLinkParam, " = ").concat(newParamValue));
    } else {
      console.debug("".concat(searchKey, " not found and newParamValue is null. Skipping."));
    }
  }
}
(function () {
  window.AF = Object.assign(window.AF || {}, {
    OneLinkUrlGenerator: OneLinkUrlGenerator
  });
})();
export default OneLinkUrlGenerator;